import { councilDashboardApi } from "@/lib/api"
import type { ApiResponseListRecentDeviceWithLeakDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetRecentDevicesWithLeaks = (councilId: number) => {
  return useQuery({
    queryKey: [useGetRecentDevicesWithLeaks.QUERY_KEY, councilId],
    queryFn: async () => {
      const response = await councilDashboardApi.getRecentDevicesWithLeaks(councilId)
      return (response.data as ApiResponseListRecentDeviceWithLeakDTO).data ?? []
    },
    enabled: !!councilId,
  })
}

useGetRecentDevicesWithLeaks.QUERY_KEY = "recent-devices-with-leaks"

export default useGetRecentDevicesWithLeaks
